module.exports = __webpack_public_path__ + "img/avatar-s-15.d50eb9cb.jpg";